import script from "./reportsDurationAnalysis.component.vue?vue&type=script&setup=true&lang=ts"
export * from "./reportsDurationAnalysis.component.vue?vue&type=script&setup=true&lang=ts"

import "./reportsDurationAnalysis.component.vue?vue&type=style&index=0&id=0a1a83d3&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1a83d3"]])

export default __exports__